<label>{{ label }}</label>
<mat-chip-list #chipList [formControl]="control">
  <mat-chip *ngFor="let item of items" (removed)="remove(item)" class="small-chip">
    {{ item }}
    <button matChipRemove>
      <lum-ui-icon
        icon="close-circle"
        [width]="18"
        [height]="18"
        color="#000000"
      ></lum-ui-icon>
    </button>
  </mat-chip>
  <input
    matInput
    type="text"
    [inputMode]="inputMode"
    [placeholder]="placeholder"
    [matChipInputFor]="chipList"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matChipInputAddOnBlur]="addOnBlur"
    (matChipInputTokenEnd)="add($event)"
    #inputField
  />
</mat-chip-list>
